export default __webpack_public_path__ + "static/media/detail-image.3501a729.png";